import React, { Component } from "react";

import queryString from "query-string";
import DataTable from "react-data-table-component";

import axios from '@app/lib/axios';
import * as Constant from "@app/Constant.js";

import RouteTitle from "@app/components/RouteTitle";
import SparklineCard from "./SparklineCard.js";

import PieChart from "@app/components/PieChart";

const CellRenderer = ({ value, diff }) => {
    if (diff == null) {
        return <span>{value}</span>;
    } else {
        return (
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pr-0">
                    <span className="">{value}</span>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pl-1">
                    <span className={diff == 0 ? "float-left text-info" : diff < 0 ? "float-left text-primary" : "float-left text-danger"} style={{ fontSize: "12px" }}>
                        <i className={diff == 0 ? "fa fa-fw fa-arrow-right" : diff < 0 ? "fa fa-fw fa-arrow-down" : "fa fa-fw fa-arrow-up"}></i>
                        {diff}
                    </span>
                </div>
            </div>
        );
    }
};

class IssueList extends Component {
    render() {
        if (this.props.issueList && this.props.issueList.length > 0) {
            return (
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <h5 className="card-header">
                            {this.props.title} 이슈
                            <span className={"float-right badge ml-1  badge-primary"}>{this.props.issueList.length}</span>
                        </h5>
                        <div className="card-body p-3">
                            {this.props.issueList.map((issue) => {
                                return (
                                    <div className="review-block" style={{ marginBottom: "8px" }}>
                                        <span className="text-dark font-weight-bold">{issue.question}</span>
                                        <p className="review-text font-italic mt-1">
                                            <i className="fas fa-arrow-alt-circle-right"></i>&nbsp;&nbsp;&nbsp;
                                            {issue.answer}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

class CsMonthly extends Component {
    constructor(props) {
        super(props);
        const query = queryString.parse(this.props.location.search);

        this.state = {
            products: [],
            product: query.product,
            productName: "",
            year: this.props.year ? this.props.year : new Date().getFullYear(),
            month: this.props.month ? this.props.month : new Date().getMonth() + 1,
            cardList: [],
            statList: [],
            chartColors: ["#5969ff", "#ff407b", "#ffc750", "#2ec551", "#ef172c", "#ffc108", "#25d5f2"],
            startDate: "",
            endDate: "",
            tableColumn: [],
            tableItems: [],
            pieData: [],
        };
    }

    handleChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        this.setState(
            {
                [name]: value,
            },
            function () {
                this.getData(this.state.product);
            }
        );
    };

    serviceChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        this.setState(
            {
                product: value,
            },
            function () {
                this.getData(value);
            }
        );
    };

    componentWillReceiveProps = (nextProps) => {
    };

    componentDidMount() {
        const { history, location } = this.props;
        const query = queryString.parse(this.props.location.search);
        if (!location.state) {
            this.getProduct();
        } else {
            this.setState({ ...location.state });
            history.replace(undefined, undefined);
        }
    }

    getProduct = () => {
        var url = Constant.API_DOMAIN + "/api/cs_info/init/0";
        axios({
            method: "get",
            url: url,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        products: result.data.products,
                    }, () => {
                        this.getData(result.data.products[0].name);
                    });
                } else {
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    getData = (product) => {
        var baseDate = this.state.year + "/" + (this.state.month >= 10 ? this.state.month : "0" + this.state.month);
        var url = Constant.API_DOMAIN + "/api/stat/monthly/";
        if (!product) {
            product = "토모노트";
        }

        url = url + product + "/" + baseDate;

        axios({
            method: "get",
            url: url,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var cardList = [];
                    /*
                    {name : "", thisMonth : "", rate : "", data : []}
                */
                    var thisMonth = this.state.month + "월";
                    var lastMonth = Number(this.state.month) - 1;
                    lastMonth = lastMonth > 0 ? lastMonth + "월" : "12월";

                    var startDate = "";
                    var endDate = "";

                    var pieData = [];

                    var totalData = {
                        name: "전체",
                        dataList: [],
                    };

                    var statTotalThisMonth = 0;
                    var statTotalLastMonth = 0;
                    result.data.weekList.map((week) => {
                        var statTotal = 0;

                        result.data.statList.forEach((stat) => {
                            statTotal += stat[week.weekName] ? stat[week.weekName] : 0;

                            if (week.weekName.indexOf(thisMonth) == 0) {
                                statTotalThisMonth += Number(stat[week.weekName]);
                            }

                            if (week.weekName.indexOf(lastMonth) == 0) {
                                statTotalLastMonth += Number(stat[week.weekName]);
                            }
                        });

                        totalData.dataList.push({
                            name: week.weekName,
                            value: statTotal,
                        });
                    });

                    totalData.thisMonth = statTotalThisMonth;
                    totalData.rate = Math.ceil(((statTotalThisMonth - statTotalLastMonth) / (statTotalLastMonth == 0 ? 1 : statTotalLastMonth)) * 100);

                    cardList.push(totalData);

                    result.data.statList.map((stat) => {
                        var dataList = [];
                        var thisMonthCnt = 0;
                        var lastMonthCnt = 0;

                        result.data.weekList.map((week) => {
                            if (week.weekName.indexOf(thisMonth) == 0) {
                                thisMonthCnt += Number(stat[week.weekName]);

                                if (!startDate) startDate = week.weekStartDate;
                                endDate = week.weekEndDate;
                            }
                            if (week.weekName.indexOf(lastMonth) == 0) {
                                lastMonthCnt += Number(stat[week.weekName]);
                                statTotalLastMonth += Number(stat[week.weekName]);
                            }

                            dataList.push({
                                name: week.weekName,
                                value: stat[week.weekName],
                            });
                        });

                        stat.rate = Math.ceil(((thisMonthCnt - lastMonthCnt) / (lastMonthCnt == 0 ? 1 : lastMonthCnt)) * 100);
                        stat.thisMonth = thisMonthCnt;

                        pieData.push({
                            id: "pieStat_" + stat.id,
                            label: stat.name,
                            value: thisMonthCnt,
                            order_num: stat.order_num,
                        });

                        stat.dataList = dataList;
                        if (stat.is_summary === "Y") {
                            cardList.push(stat);
                        }
                    });

                    pieData.sort((a, b) => a.order_num - b.order_num);

                    var tableColumn = [
                        {
                            name: "주차",
                            selector: "week",
                            sortable: true,
                        },
                        {
                            name: "미처리",
                            selector: "waiting",
                            minWidth: "115px",
                            sortable: true,
                            cell: (row) => {
                                if (row.isTotal) {
                                    return <CellRenderer value={row["waiting"]} diff={row["waiting_diff"]} />;
                                } else {
                                    return row["waiting"];
                                }
                            },
                        },
                    ];

                    var tableList = [];
                    var sortedWeekList = result.data.weekList.sort((a, b) => {
                        var yearDiff = a.weekInfo.year - b.weekInfo.year;
                        if (yearDiff !== 0) {
                            return yearDiff * -1;
                        }

                        var monthDiff = a.weekInfo.month - b.weekInfo.month;
                        var returnVal = monthDiff * -1;

                        if (monthDiff === 0) {
                            returnVal = b.weekInfo.week - a.weekInfo.week;
                        }

                        return returnVal;
                    });

                    var sortedTypeList = result.data.statList.sort((a, b) => {
                        return a.order_num - b.order_num;
                    });

                    sortedTypeList.forEach((type) => {
                        tableColumn.push({
                            name: type.name,
                            selector: "type_" + type.id,
                            minWidth: "115px",
                            sortable: true,
                            cell: (row) => {
                                if (row.isTotal) {
                                    return <CellRenderer value={row["type_" + type.id]} diff={row["type_" + type.id + "_diff"]} />;
                                } else {
                                    return row["type_" + type.id];
                                }
                            },
                        });
                    });

                    var month = this.state.month;
                    var lastMonth = 0;
                    var montlyTotal = {};
                    sortedWeekList.forEach((week, index) => {
                        if (month != week.weekInfo.month) {
                            montlyTotal.week = month + "월 힙계";
                            montlyTotal.isTotal = true;
                            tableList.push(montlyTotal);
                            month = week.weekInfo.month;
                            montlyTotal = {};
                        }

                        var obj = {
                            week: week.weekName,
                            date: week.date,
                            minWidth: 150,
                            center: true,
                        };

                        var waiting = 0;
                        sortedTypeList.forEach((type) => {
                            obj["type_" + type.id] = type[week.weekName];

                            waiting += type[week.weekName + "_waiting"];

                            var typeMonthlTotal = montlyTotal["type_" + type.id] ? montlyTotal["type_" + type.id] : 0;
                            typeMonthlTotal += type[week.weekName];

                            montlyTotal["type_" + type.id] = typeMonthlTotal;
                            lastMonth += typeMonthlTotal;
                        });
                        obj.waiting = waiting;

                        montlyTotal["waiting"] = montlyTotal["waiting"] ? montlyTotal["waiting"] + waiting : waiting;

                        tableList.push(obj);
                        if (index === sortedWeekList.length - 1) {
                            montlyTotal.week = month + "월 힙계";
                            montlyTotal.isTotal = true;
                            tableList.push(montlyTotal);
                        }
                    });

                    var lastMonthTotal = null;
                    for (var i = tableList.length - 1; i >= 0; i--) {
                        var tableItem = tableList[i];
                        if (tableItem.isTotal) {
                            if (lastMonthTotal == null) {
                                lastMonthTotal = tableItem;
                            } else {
                                var keyList = Object.keys(tableItem);
                                keyList.forEach((key) => {
                                    if (key.indexOf("type_") == 0 || key == "waiting") {
                                        var diffLastMonth = tableItem[key] - lastMonthTotal[key];
                                        tableItem[key + "_diff"] = diffLastMonth;
                                    }
                                });

                                lastMonthTotal = tableItem;
                            }
                        }
                    }

                    this.setState(
                        {
                            product: product,
                            productName: result.data.product_name,
                            statList: result.data.statList,
                            cardList: cardList,
                            startDate: startDate,
                            endDate: endDate,
                            tableColumn: tableColumn,
                            tableItems: tableList,
                            pieData: pieData,
                        },
                        () => {
                            // this.props.history.replace(undefined, { ...this.state });
                        }
                    );
                } else {
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    chartOption = {
        legend: {
            position: "left",
        },
        maintainAspectRatio: false,
        responsive: true,
    };

    conditionalRowStyles = [
        {
            when: (row) => row.isTotal,
            style: {
                backgroundColor: "#dffaff !important",
                color: "#25d5f2 !important",
                cursor: "default",
            },
        },
    ];

    rowClick = (data) => {
        if (!data.isTotal) document.location.href = "/weekly_report?product=" + this.state.product + "?&date=" + data.date;
    };

    render() {
        const years = [];
        const currentYear = (new Date()).getFullYear();
        for(let i = currentYear; i >= 2018; i--) {
            years.push(i);
        }
        const {products} = this.state;
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">{this.state.productName + " " + this.state.year + "년 " + this.state.month + "월 CS 리포트"}</h2>
                                    <span>
                                        {this.state.startDate} ~ {this.state.endDate}
                                    </span>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="row">
                                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 float-right">
                                        <select className="form-control form-control-lg" name="service" value={this.state.productName} onChange={this.serviceChange} style={{ fontSize: "1.3em" }}>
                                            {products.map((s) => <option>{s.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 float-right">
                                        <select className="form-control form-control-lg" name="year" value={this.state.year} onChange={this.handleChange} style={{ fontSize: "1.3em" }}>
                                            {years.map((y) => <option>{y}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                                        <select className="form-control form-control-lg" name="month" value={this.state.month} onChange={this.handleChange} style={{ fontSize: "1.3em" }}>
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                            <option>6</option>
                                            <option>7</option>
                                            <option>8</option>
                                            <option>9</option>
                                            <option>10</option>
                                            <option>11</option>
                                            <option>12</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                                {this.state.cardList.map((stat, index) => {
                                    if (index % 2 == 0) {
                                        return (
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" key={"stat_" + stat.id}>
                                                <SparklineCard title={stat.name} value={stat.thisMonth} data={stat.dataList} rate={stat.rate} strokeColor={this.state.chartColors[index]} />
                                            </div>
                                        );
                                    }
                                })}
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="card">
                                    <div className="card-body" style={{ height: "520px" }}>
                                        <PieChart data={this.state.pieData} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                                {this.state.cardList.map((stat, index) => {
                                    if (index % 2 == 1) {
                                        return (
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" key={"stat_" + stat.id}>
                                                <SparklineCard title={stat.name} value={stat.thisMonth} data={stat.dataList} rate={stat.rate} strokeColor={this.state.chartColors[index]} />
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <DataTable
                                            columns={this.state.tableColumn}
                                            data={this.state.tableItems}
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            noHeader
                                            fixedHeader
                                            fixedHeaderScrollHeight={"500px"}
                                            striped={true}
                                            conditionalRowStyles={this.conditionalRowStyles}
                                            onRowClicked={this.rowClick}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {this.state.statList.map((stat, index) => {
                                return <IssueList issueList={stat.issueList} title={stat.name} key={"issueStat_" + stat.id} />;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CsMonthly;
